import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminAuthService } from '../services/api';

/**
 * AdminProtectedRoute component to handle admin authentication-based routing
 * Redirects to admin login page if admin is not authenticated
 */
const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAdminAuthenticated = adminAuthService.isAuthenticated();

  if (!isAdminAuthenticated) {
    // Redirect to admin login page if not authenticated
    // Save the attempted URL for redirecting after successful login
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminProtectedRoute;
